"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
import ApiService from "./api_service";
import ObjectWithIDStore from "../stores/object_with_id_store";
import fetch from "../util/fetch";
import Account from "../api/account";
const carrier_term = Account.carrierTerm();
const unknownCarrier = {
  id: "",
  name: "Unknown " + carrier_term
};
class CarrierService {
  constructor() {
    __publicField(this, "store");
    __publicField(this, "idsBeingFetched");
    this.store = new ObjectWithIDStore();
    this.idsBeingFetched = {};
  }
  isCurrentlyFetching(id) {
    return this.idsBeingFetched[id];
  }
  fetching(id, promise) {
    this.idsBeingFetched[id] = promise;
  }
  doneFetching(id) {
    delete this.idsBeingFetched[id];
  }
  getCarrier(id) {
    return this.store.index[id];
  }
  getCarrierOrUnknown(id) {
    return this.getCarrier(id) || unknownCarrier;
  }
  carrierWithId(carrierId) {
    if (this.store.index[carrierId]) {
      return Promise.resolve(this.store.index[carrierId]);
    }
    return this.fetchAndReturnPromise(carrierId);
  }
  createAddress(carrier, paymentStrategy, paymentDetails) {
    const details = { payment_strategy: paymentStrategy };
    if (paymentStrategy === "direct") {
      details.payment_address = paymentDetails;
    } else {
      details.factoring_company_office_id = paymentDetails.id;
    }
    return ApiService.addErrorHandler(
      // TODO: use fetch instead
      // eslint-disable-next-line no-restricted-syntax
      $.post(`/api/carriers/${carrier.id}/payment_addresses`, details).then(
        (result) => {
          this.store.addOrUpdate(result.carrier);
        }
      )
    );
  }
  updateCarrier(carrier) {
    const updatedCarrier = this.store.addOrUpdate(carrier);
    $(this).trigger("carrier_service:updated");
    return updatedCarrier;
  }
  updateCarriers(carriers) {
    const updatedCarriers = this.store.addOrUpdateAll(carriers);
    $(this).trigger("carrier_service:updated");
    return this.store.addOrUpdateAll(updatedCarriers);
  }
  fetchAndReturnPromise(carrierId) {
    if (carrierId) {
      let promise = this.isCurrentlyFetching(carrierId);
      if (!promise) {
        promise = ApiService.addErrorHandler(
          fetch(`/api/carriers/${carrierId}`).then((result) => {
            const existing = this.store.addOrUpdate(result.carrier);
            this.doneFetching(carrierId);
            return existing;
          }, _.identity)
        );
        this.fetching(carrierId, promise);
      }
      return promise;
    }
    return Promise.resolve(unknownCarrier);
  }
}
const carrierService = new CarrierService();
export default carrierService;
